module.exports = __webpack_public_path__ + "img/OPUS blir en del av TERRAVERA Business Program.d42a26e9.png";